<script>
  // import Swiper core and required modules
  import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from "swiper";

  import { Router, Link, Route, navigate } from "svelte-routing";

  import { Swiper, SwiperSlide } from "swiper/svelte";

  import { Lightbox } from "svelte-lightbox";

  import { onMount } from "svelte";

  import { MetaTags } from "svelte-meta-tags";

  // Import Swiper styles
  import "swiper/css";
  import "swiper/css/navigation";
  import "swiper/css/pagination";
  import "swiper/css/scrollbar";
  import { each } from "svelte/internal";
  // import Wishlist from "./wishlist.svelte";

  const API_END_POINT = END_POINT;
  const product_api_url = API_END_POINT + "single.php";
  const wishlist_api_url = API_END_POINT + "iswishlist.php";
  const comments_api_url = API_END_POINT + "is_commented.php";
  const delete_wishslist_api_url = API_END_POINT + "delete_from_wishlist.php";
  const add_wishslist_api_url = API_END_POINT + "add_to_wishlist.php";
  const get_comments_api_url = API_END_POINT + "get_comments.php";
  const add_tocart_api_url = API_END_POINT + "add_to_cart.php";
  const savecomment_api_url = API_END_POINT + "savecomment.php";

  const user = localStorage.getItem("us");
  const user_name = localStorage.getItem("uname");

  let product_data = [];
  let comment_data_results = [];
  let images = [];
  let product_id = "";
  let IsWishlist,
    Iscommented,
    comment_data_results_3 = "";
  let Wishlist_id = "";
  let iscommentsempty = "";
  let src = "";
  let page_url = "";

  let set_product_size = "";
  let set_product_quantity = "";
  let set_selected_size = "";
  let set_selected_quantity_id = "";

  let size_selector = "";
  let set_size = "";

  // let today = new Date().toLocaleDateString()

  function goback() {
    history.back();
  }

  function change_size() {
    if (size_selector.value == product_data.s1) {
      // available_sizes.innerHTML = product_data.q1;
      set_size.value = "1";
      set_size.max = product_data.q1;
      set_selected_size = "s1";
      set_selected_quantity_id = "q1";
    } else if (size_selector.value == product_data.s2) {
      // available_sizes.innerHTML = product_data.q2;
      set_size.value = "1";
      set_size.max = product_data.q2;
      set_selected_size = "s2";
      set_selected_quantity_id = "q2";
    } else if (size_selector.value == product_data.s3) {
      // available_sizes.innerHTML = product_data.q3;
      set_size.value = "1";
      set_size.max = product_data.q3;
      set_selected_size = "s3";
      set_selected_quantity_id = "q3";
    } else if (size_selector.value == product_data.s4) {
      // available_sizes.innerHTML = product_data.q4;
      set_size.value = "1";
      set_size.max = product_data.q4;
      set_selected_size = "s4";
      set_selected_quantity_id = "q4";
    } else if (size_selector.value == product_data.s5) {
      // available_sizes.innerHTML = product_data.q5;
      set_size.value = "1";
      set_size.max = product_data.q5;
      set_selected_size = "s5";
      set_selected_quantity_id = "q5";
    }
  }

  function setsize_initial() {
    size_selector.selectedIndex = 0;
    // console.log(size_selector.value);
  }

  function remove_placeholder() {
    const nodeList = document.querySelectorAll(".placeholder");
    for (var i = 0; i < nodeList.length; i++) {
      nodeList[i].classList.remove("placeholder");
    }
  }

  onMount(() => {
    window.scrollTo(0, 0);

    const user = localStorage.getItem("us");

    if (user === null || user === "") {
      navigate("/login");
    } else {
      page_url = window.location.href + "?share_url";
      // console.log(product_api_url);
      let currentpath = window.location.pathname;
      let path_decode = currentpath.split("/");
      product_id = path_decode[2];
      //console.log(product_id);

      size_selector = document.getElementById("sizes");
      set_size = document.getElementById("quan");

      size_selector.addEventListener("change", change_size);
      // size_selector.addEventListener("load",setsize);

      getproductdata();
    }
  });

  async function getproductdata() {
    const response = await fetch(product_api_url, {
      method: "POST",
      body: JSON.stringify({ pid: product_id }),
    });
    const data = await response.json();
    product_data = data[0];

    if (product_data === undefined) {
      // location.replace("/NotFound");

      let NotAvailable_Modal = new bootstrap.Modal(
        document.getElementById("not_available_modal"),
        {}
      );
      NotAvailable_Modal.show();
    }

    if (
      product_data.q1 == 0 &&
      product_data.q2 == 0 &&
      product_data.q3 == 0 &&
      product_data.q4 == 0 &&
      product_data.q5 == 0
    ) {
      // location.replace("/NotFound");
      let NotAvailable_Modal = new bootstrap.Modal(
        document.getElementById("not_available_modal"),
        {}
      );
      NotAvailable_Modal.show();
    }

    if (product_data.q1 != 0) {
      set_product_size = product_data.s1;
      set_selected_size = "s1";
      set_selected_quantity_id = "q1";
      set_size.max = product_data.q1;
      // console.log("q1");
    } else if (product_data.q1 == 0 && product_data.q2 != 0) {
      set_product_size = product_data.s2;
      set_selected_size = "s2";
      set_selected_quantity_id = "q2";
      set_size.max = product_data.q2;
      // console.log("q2");
    } else if (
      product_data.q1 == 0 &&
      product_data.q2 == 0 &&
      product_data.q3 != 0
    ) {
      set_product_size = product_data.s3;
      set_selected_size = "s3";
      set_selected_quantity_id = "q3";
      set_size.max = product_data.q3;
      // console.log("q3");
    } else if (
      product_data.q1 == 0 &&
      product_data.q2 == 0 &&
      product_data.q3 == 0 &&
      product_data.q4 != 0
    ) {
      set_product_size = product_data.s4;
      set_selected_size = "s4";
      set_selected_quantity_id = "q4";
      set_size.max = product_data.q4;
      // console.log("q4");
    } else if (
      product_data.q1 == 0 &&
      product_data.q2 == 0 &&
      product_data.q3 == 0 &&
      product_data.q4 == 0 &&
      product_data.q5 != 0
    ) {
      set_product_size = product_data.s5;
      set_selected_size = "s5";
      set_selected_quantity_id = "q5";
      set_size.max = product_data.q5;
      // console.log("q5");
    }

    // console.log(product_data);
    const product_images = product_data.product_images;
    images = product_images.split(",");

    src = "https://imagecdn.veeranfashions.com/" + images[0];

    get_is_wishlist();

    get_comments();

    get_is_commented();
  }

  function share_to() {
    var currentUrl = window.location.href;
    NativeAndroid.shareto(currentUrl);
  }

  async function get_comments() {
    const comment_response = await fetch(get_comments_api_url, {
      method: "POST",
      body: JSON.stringify({ pid: product_id }),
    });
    const comment_data = await comment_response.json();
    comment_data_results = comment_data;
    comment_data_results_3 = comment_data[2];

    // console.log(comment_data_results_3);style

    if (comment_data_results.length === 0) {
      iscommentsempty = true;
      // console.log(iscommentsempty);
    }
  }

  /************************************************
   * Product Quantity
   ***********************************************/

  async function get_is_wishlist() {
    const wishlist_response = await fetch(wishlist_api_url, {
      method: "POST",
      body: JSON.stringify({ pid: product_id, uid: user }),
    });
    const wish_list_data = await wishlist_response.json();
    IsWishlist = wish_list_data.iswishlist;
    Wishlist_id = wish_list_data.wid;
    // console.log(IsWishlist);
  }

  async function get_is_commented() {
    const iscommented_response = await fetch(comments_api_url, {
      method: "POST",
      body: JSON.stringify({ pid: product_id, uid: user }),
    });
    const iscommented_response_data = await iscommented_response.json();
    Iscommented = iscommented_response_data.is_commented;
    // console.log(Iscommented);
  }

  async function add_to_cart() {
    set_product_quantity = document.getElementById("quan").value;

    set_product_size = size_selector.value;

    const addtocart_response = await fetch(add_tocart_api_url, {
      method: "POST",
      body: JSON.stringify({
        pname: product_data.product_name,
        pid: product_data.no,
        psize: set_product_size,
        pquantity: set_product_quantity,
        psizeid: set_selected_size,
        pquantity_id: set_selected_quantity_id,
        pimage: images[0],
        uid: user,
        price: product_data.product_discounted_price,
      }),
    });
    const cart_data_response = await addtocart_response.json();
    // console.log(cart_data_response);
    if (cart_data_response.isadded == "success") {
      let Addtocart_Modal = new bootstrap.Modal(
        document.getElementById("addtocart_modal"),
        {}
      );
      Addtocart_Modal.show();
    }
  }

  async function savecomment() {
    const getcomment = document.getElementById("yourcomment").value;

    if (getcomment == null || getcomment == undefined || getcomment == "") {
      alert("You Have not Entered any comment!");
    } else {
      const save_comment = await fetch(savecomment_api_url, {
        method: "POST",
        body: JSON.stringify({
          pid: product_data.no,
          uid: user,
          uname: user_name,
          comment: getcomment,
        }),
      });
      const save_comment_response = await save_comment.json();
      // console.log(cart_data_response);
      if (save_comment_response.is_comment_added == "yes") {
        let Comment_added_modal = new bootstrap.Modal(
          document.getElementById("comment_added_modal"),
          {}
        );
        Comment_added_modal.show();
      } else {
        alert("sorry! we cant add your comment now.");
      }
    }
  }

  function reload() {
    window.location.reload();
  }

  function gotocart() {
    var go_tocrat_modelElem = document.getElementById("addtocart_modal");
    var go_tocrat_modelInstance =
      bootstrap.Modal.getInstance(go_tocrat_modelElem);
    go_tocrat_modelInstance.hide();
    navigate("/cart");
  }

  function increaseCount() {
    var input = document.getElementById("quan");
    var maxvalue = input.max;
    var value = parseInt(input.value, 10);
    if (value < maxvalue) {
      value = isNaN(value) ? 0 : value;
      value++;
      input.value = value;
    }
  }

  function decreaseCount() {
    var input = document.getElementById("quan");
    var value = parseInt(input.value, 10);
    if (value > 1) {
      value = isNaN(value) ? 0 : value;
      value--;
      input.value = value;
    }
  }

  function reloadpage() {
    window.location.reload();
  }

  function Show_Delete_Modal() {
    let Delete_Modal = new bootstrap.Modal(
      document.getElementById("delete_modal"),
      {}
    );
    Delete_Modal.show();
  }

  function Hide_Delete_Modal() {
    // to hide delete modal
    var modalInstance = null;
    var modelElem = document.getElementById("delete_modal");
    modalInstance = bootstrap.Modal.getInstance(modelElem);
    modalInstance.hide();
  }

  function Hide_Add_Modal() {
    // to hide delete modal
    var modalInstance = null;
    var modelElem = document.getElementById("add_modal");
    modalInstance = bootstrap.Modal.getInstance(modelElem);
    modalInstance.hide();
  }

  async function delete_wishlist(wid) {
    const delete_wishlist_response = await fetch(delete_wishslist_api_url, {
      method: "POST",
      body: JSON.stringify({ uid: user, wid: wid }),
    });
    const delete_wish_list_data = delete_wishlist_response.json();
    if ((delete_wish_list_data.isdeleted = "yes")) {
      Show_Delete_Modal();
      get_is_wishlist();
      setTimeout(Hide_Delete_Modal, 1000);
    }
  }

  async function add_to_wishlist(wid) {
    const add_wishlist_response = await fetch(add_wishslist_api_url, {
      method: "POST",
      body: JSON.stringify({
        pid: product_data.no,
        pname: product_data.product_name,
        apid: product_data.product_id,
        pimage: images[0],
        uid: user,
      }),
    });
    const add_wishslist_data = add_wishlist_response.json();
    if ((add_wishslist_data.isadded = "success")) {
      let Add_Modal = new bootstrap.Modal(
        document.getElementById("add_modal"),
        {}
      );
      Add_Modal.show();
      get_is_wishlist();
      setTimeout(Hide_Add_Modal, 1000);
    }
  }
</script>

<svelte:head>
  <!-- Bootstrap JavaScript Bundle with Popper -->
  <!-- Bootstrap JavaScript Bundle with Popper -->
  <!-- Bootstrap JavaScript Bundle with Popper -->
  <!-- Bootstrap JavaScript Bundle with Popper -->
  <script
    src="https://cdn.jsdelivr.net/npm/bootstrap@5.2.0/dist/js/bootstrap.bundle.min.js"
    integrity="sha384-A3rJD856KowSb7dwlZdYEkO39Gagi7vIsF0jrRAoQmDKKtQBHUuLZ9AsSv4jD4Xa"
    crossorigin="anonymous"
  ></script>

  <!-- Primary Meta Tags -->
  <title>{product_data.product_name} | Veerun Fashions</title>

  <MetaTags
    title="{product_data.product_name} | Veerun Fashions"
    description={product_data.product_description}
  />
</svelte:head>

<main class="main-wrapper">
  <!-- ...:::Start User Event Section:::... -->
  <div class="header-section">
    <div class="container">
      <!-- Start User Event Area -->
      <div class="header-area">
        <div class="header-top-area header-top-area--style-1">
          <ul class="event-list">
            <li class="list-item">
              <span
                onclick="goback()"
                area-label="mobile menu offcanvas svg icon"
                class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow main-menu offcanvas-toggle offside-menu"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-caret-left-fill"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"
                  />
                </svg>
              </span>
            </li>
            <li class="list-item">
              <h2 class="title text-center">Product</h2>
            </li>
            <li class="list-item">
              <ul class="list-child">
                <li class="list-item">
                  <span class="notch-bg" />
                  <Link
                    to="cart"
                    area-label="Cart"
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-cart-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                      />
                    </svg>
                  </Link>
                </li>
                <li class="list-item">
                  <span class="notch-bg" />
                  <button
                    on:click={share_to}
                    class="btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
                    id="sharebutton"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-share-fill"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5z"
                      />
                    </svg>
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!-- End User Event Area -->
    </div>
  </div>
  <!-- ...:::End User Event Section:::... -->

  <!-- ...:::Start Product Single Section:::... -->
  <div class="product-single-section section-gap-top-30">
    <div class="container">
      <div class="product-gallery-image">
        <div class="swiper single">
          <!-- Slider main container -->
          <Swiper
            class="swiper swiper-initialized swiper-horizontal swiper-pointer-events rounded placeholder-glow"
            modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
            pagination={{ clickable: true, el: ".swiper-pagination" }}
            loop={true}
            autoplay={{ delay: 2500, disableOnInteraction: false }}
          >
            <!-- Slides -->
            {#each images as image}
              <SwiperSlide class="rounded">
                <div class="product-gallery-single-item">
                  <div class="image">
                    <Lightbox>
                      <picture>
                        <source
                          srcset="https://imagecdn.veeranfashions.com/webp/{image.replace(
                            'png',
                            'webp'
                          )}"
                          type="image/webp"
                          alt="product"
                        />
                        <source
                          srcset="https://imagecdn.veeranfashions.com/{image}"
                          type="image/png"
                        />
                        <img
                          class="img-fluid rounded placeholder"
                          width="276"
                          height="172"
                          src="https://imagecdn.veeranfashions.com/{image}"
                          alt=""
                          id="product_image"
                          on:load={remove_placeholder}
                        />
                      </picture>
                    </Lightbox>
                  </div>
                </div>
              </SwiperSlide>
            {/each}
          </Swiper>
        </div>
        <!-- If we need pagination -->
        <div class="pt-2 swiper-pagination" />

        <div class="product-tag position-relative">
          {#if IsWishlist == "yes"}
            <button
              id="wishlist_button"
              on:click={delete_wishlist(Wishlist_id)}
              class="position-absolute top-0 end-0 btn btn--size-33-33 btn--center btn--round btn--color-radical-red btn--bg-white btn--box-shadow"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-heart-fill"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
                />
              </svg>
            </button>
          {:else}
            <button
              id="wishlist_button"
              on:click={add_to_wishlist(Wishlist_id)}
              class="position-absolute top-0 end-0 btn btn--size-33-33 btn--center btn--round btn--color-pink-swan btn--bg-white btn--box-shadow"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-heart"
                viewBox="0 0 16 16"
              >
                <path
                  d="m8 2.748-.717-.737C5.6.281 2.514.878 1.4 3.053c-.523 1.023-.641 2.5.314 4.385.92 1.815 2.834 3.989 6.286 6.357 3.452-2.368 5.365-4.542 6.286-6.357.955-1.886.838-3.362.314-4.385C13.486.878 10.4.28 8.717 2.01L8 2.748zM8 15C-7.333 4.868 3.279-3.04 7.824 1.143c.06.055.119.112.176.171a3.12 3.12 0 0 1 .176-.17C12.72-3.042 23.333 4.867 8 15z"
                />
              </svg>
            </button>
          {/if}
        </div>
      </div>
    </div>

    <div class="container px-0 py-0">
      <div class="product-gallery-details">
        <span class="rating" hidden>Rating 4.0 of 5</span>
        <h1 class="title text-colored">{product_data.product_name}</h1>

        <p class="text">
          {product_data.product_description}
        </p>

        <ul class="product-variable-lists">
          <li class="list-item">
            <div class="left">Size</div>
            <div class="right">
              <select
                name="sizes"
                id="sizes"
                class="form-select form-select-sm"
                on:load={setsize_initial}
              >
                {#if product_data.s1 != "default" && product_data.q1 != 0}
                  <option value={product_data.s1}>{product_data.s1}</option>
                {/if}
                {#if product_data.s2 != "default" && product_data.q2 != 0}
                  <option value={product_data.s2}>{product_data.s2}</option>
                {/if}
                {#if product_data.s3 != "default" && product_data.q3 != 0}
                  <option value={product_data.s3}>{product_data.s3}</option>
                {/if}
                {#if product_data.s4 != "default" && product_data.q4 != 0}
                  <option value={product_data.s4}>{product_data.s4}</option>
                {/if}
                {#if product_data.s5 != "default" && product_data.q5 != 0}
                  <option value={product_data.s5}>{product_data.s5}</option>
                {/if}
              </select>
            </div>
          </li>
          <!-- <li class="list-item">
            <div class="left">Stock</div>
            <div class="right padding-left-50">
              <ul class="size-chart inner-child-item">
                <li>
                  <label for="Avail">
                    <span
                      class="form-control form-control-sm"
                      id="available_sizes">{product_data.q1}</span
                    >
                  </label>
                </li>
              </ul>
            </div>
          </li> -->
          <li class="list-item">
            <div class="left">Qty</div>
            <div class="right">
              <div class="product-quantity">
                <div class="num-block skin-2">
                  <div class="num-in">
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <span class="minus dis" on:click={decreaseCount} />
                    <input
                      id="quan"
                      type="number"
                      min="1"
                      max=""
                      class="in-num"
                      value="1"
                      readonly=""
                    />
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <span class="plus" on:click={increaseCount} />
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>

        <div class="price-n-cart pb-5">
          <span class="price"
            >&#8377 {product_data.product_discounted_price}</span
          >
          <button class="btn cart" type="button" on:click={add_to_cart}>
            <span class="icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-cart-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm-7 1a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm7 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
                />
              </svg>
            </span>Add to Cart</button
          >
        </div>

        <div class="price-n-cart pt-5" hidden>
          <button
            href="./"
            data-bs-toggle="modal"
            data-bs-target="#FailModal"
            class="btn cart">Fail Modal</button
          >
        </div>
        <div class="price-n-cart pt-5" hidden>
          <button
            data-bs-toggle="modal"
            data-bs-target="#SuccessModal"
            class="btn cart">Success Modal</button
          >
        </div>
        <hr />
        <div class="mb-3">
          <span class="text-colored">
            {#if comment_data_results_3}3{/if} Latest Reviews</span
          >
          <div class="cart-section section-gap-top-30">
            <div class="container">
              <div class="cart-items-wrapper">
                <ul class="cart-item-list">
                  {#if iscommentsempty != true}
                    {#each comment_data_results as comment_data_result}
                      <li class="single-cart-item">
                        <div class="content">
                          <p class="title">
                            {comment_data_result.commented_by}
                          </p>
                          <div class="details">
                            <div class="left">
                              <span class="text-dark"
                                >{comment_data_result.comment}</span
                              >
                            </div>
                          </div>
                        </div>
                      </li>
                    {/each}
                  {:else}
                    <h6 class="text-colored">No Comments available</h6>
                  {/if}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <label for="yourcomment" class="form-label">Write your Review</label><br
        />
        {#if Iscommented === "no"}
          <div class="mb-3">
            <textarea class="form-control" id="yourcomment" rows="3" /><br />
            <button type="button" class="btn btn-submit" on:click={savecomment}
              >Submit your Review</button
            >
          </div>
        {:else}
          <h6 class="text-colored">You Have already commented on this post.</h6>
        {/if}
      </div>
    </div>
  </div>
  <!-- ...:::End Product Single Section:::... -->

  <!-- ...:::Start User Event Section:::... -->
  <div class="user-event-section">
    <!-- Start User Event Area -->
    <div class="col pos-relative">
      <div class="user-event-area">
        <div class="nav">
          <Link to="/" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-house-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z"
              />
              <path
                fill-rule="evenodd"
                d="M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z"
              />
            </svg>
            <br />
            <h6>Home</h6>
          </Link>
          <Link to="/wishlist" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-heart-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"
              />
            </svg>
            <br />
            <h6>Wishlist</h6>
          </Link>
          <Link to="/shop" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-grid-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z"
              />
            </svg>
            <br />
            <h6>Shop</h6>
          </Link>

          <Link to="/orders" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-box-seam-fill"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15.528 2.973a.75.75 0 0 1 .472.696v8.662a.75.75 0 0 1-.472.696l-7.25 2.9a.75.75 0 0 1-.557 0l-7.25-2.9A.75.75 0 0 1 0 12.331V3.669a.75.75 0 0 1 .471-.696L7.443.184l.01-.003.268-.108a.75.75 0 0 1 .558 0l.269.108.01.003 6.97 2.789ZM10.404 2 4.25 4.461 1.846 3.5 1 3.839v.4l6.5 2.6v7.922l.5.2.5-.2V6.84l6.5-2.6v-.4l-.846-.339L8 5.961 5.596 5l6.154-2.461L10.404 2Z"
              />
            </svg>
            <br />
            <h6>Orders</h6>
          </Link>

          <Link to="/settings" class="nav__link">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="currentColor"
              class="bi bi-gear-fill"
              viewBox="0 0 16 16"
            >
              <path
                d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872l-.1-.34zM8 10.93a2.929 2.929 0 1 1 0-5.86 2.929 2.929 0 0 1 0 5.858z"
              />
            </svg>
            <br />
            <h6>Settings</h6>
          </Link>
        </div>
      </div>
    </div>
    <!-- End User Event Area -->
  </div>
  <!-- ...:::End User Event Section:::... -->

  <div
    class="modal slide-top"
    id="comment_added_modal"
    tabindex="-1"
    aria-hidden="true"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass rounded-4 shadow">
        <div class="modal-body p-5">
          <h2 class="fw-bold mb-0 pb-5">Your Comment Added</h2>

          <button
            type="button"
            class="btn btn-sm btn-submit mt-5 w-100"
            data-bs-dismiss="modal"
            on:click={reload}>Done</button
          >
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal slide-top"
    id="addtocart_modal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass rounded-4 shadow">
        <div class="modal-body p-5">
          <h2 class="fw-bold mb-0 pb-5">Added to Cart</h2>

          <img
            class="img-fluid rounded"
            width="128px"
            height="128px"
            {src}
            alt=""
          />

          <button
            type="button"
            on:click={gotocart}
            class="btn btn-sm btn-submit mt-5 w-100"
            data-bs-dismiss="modal">Go to Cart Page</button
          >
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal slide-top"
    tabindex="-1"
    id="add_modal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass">
        <div class="modal-header">
          <h5 class="modal-title">Veeranfashions</h5>
        </div>
        <div class="modal-body">
          <p>Product Added to Your Wishlist</p>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal slide-top"
    tabindex="-1"
    id="delete_modal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass">
        <div class="modal-header">
          <h5 class="modal-title">Veeranfashions</h5>
        </div>
        <div class="modal-body">
          <p>Product Deleted From your Wishlist</p>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal slide-top"
    tabindex="-1"
    id="not_available_modal"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center glass">
        <div class="modal-header">
          <h5 class="modal-title">Veeranfashions</h5>
        </div>
        <div class="modal-body">
          <p>Product Stock Currently Not Available</p>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn btn btn-submit"
            data-bs-dismiss="modal"
            on:click={goback}>Go Back</button
          >
        </div>
      </div>
    </div>
  </div>

  <footer class="footer-section" />
</main>
